module.exports = __webpack_public_path__ + "static/screenshot-kickass-by-laura-philipp-ae0bf5f745c98207af37e486e47e6dde.png";